import decode from 'jwt-decode'
import axios from 'axios'
import api_config from "@/config";
import i18n from '@/i18n';

const REST_ENDPOINT = api_config.API_ENDPOINT

const AUTH_TOKEN_KEY = 'authToken'

export async function loginUser(username, password) {
    let data = {}
    try {
        let res = await axios({
            url: REST_ENDPOINT + '/auth/token/',
            method: 'POST',
            data: {
                username: username,
                password: password
            }
        })
        if (res.status === 200 && res.data.token) {
            setAuthToken(res.data.token)
            const token = getAuthToken()
            if (token) {
                data.status = res.status
                data.message = 'Successful login'
            } else {
                data.message = 'Retry connexion'
            }
        }
    } catch (err) {
        data.status = err.response.status;
        if (err.response.status === 403) {
                data.message = err.response.data['detail'] || i18n.global.t('login.account_blocked');
        } else {
                data.message = err.response.data['non_field_errors'] ? err.response.data['non_field_errors'][0] : i18n.global.t('login.error_occurred');
        }
        if (process.env.NODE_ENV !== 'production') {
            console.log(data.message);
            console.error('Caught an error during login:', err);
        }
    }
    return data
}

export async function getConfig(isAuthenticated = true) {
    let response;
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/config/`,
            method: "GET",
        });

        if (res.status === 200) {
            response = res.data;
            localStorage.setItem("currencyCode", response[0].currency_symbol);
        }
    } catch (err) {
        response = err.response;
        console.error('Caught an error during get config:', err)
    }
    return response;
}

export async function updateStudentCount(configId, student_count, isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/config/${configId}/`,
            method: "PATCH",
            data: {
                student_count: parseInt(student_count, 10)
            }
        });

        if (res.status === 200) {
            response = res;
            console.log("Student count updated successfully:", res.data);
        }
    } catch (err) {
        response = err.response;
        console.error('Caught an error during update student count:', err);
    }
    return response;
}

export async function updateSchoolName(configId, school_name, isAuthenticated=true) {
    if (isAuthenticated) {
        const token = localStorage.getItem("authToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    let response;
    try {
        const res = await axios({
            url: `${REST_ENDPOINT}/api/config/${configId}/`,
            method: "PATCH",
            data: {
                school_name: school_name
            }
        });

        if (res.status === 200) {
            response = res;
            console.log("Student count updated successfully:", res.data);
        }
    } catch (err) {
        response = err.response;
        console.error('Caught an error during update student count:', err);
    }
    return response;
}

export async function ResetPassword(username) {
    try {
        const res = await axios({
            url: REST_ENDPOINT + "/api/generate_reset_password_link",
            method: "POST",
            data: {
                username: username
            }
        });

        return {
            status: res.status,
            data: res.data
        };
    } catch (err) {
        console.error("Erreur lors de la récupération des notes :", err);
        throw err;
    }
}


export function logoutUser() {
    clearAuthToken()
    window.location.reload()
}

export function setAuthToken(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    localStorage.setItem(AUTH_TOKEN_KEY, token)
}

export function getAuthToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY)
}

export function clearAuthToken() {
    axios.defaults.headers.common['Authorization'] = ''
    localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function isLoggedIn() {
    let authToken = getAuthToken()
    return !!authToken && !isTokenExpired(authToken)
}

export function getUserInfo() {
    if (isLoggedIn()) {
        return decode(getAuthToken())
    }
}

function getTokenExpirationDate(encodedToken) {
    let token = decode(encodedToken)
    if (!token.exp) {
        return null
    }

    let date = new Date(0)
    date.setUTCSeconds(token.exp)

    return date
}

function isTokenExpired(token) {
    let expirationDate = getTokenExpirationDate(token)
    return expirationDate < new Date()
}




